import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Header from '../../Header/index';
import ReportReception from './ReportReception';
import ReportStock from './ReportStock';
import ControlMeters from './ControlMeters';

class ReportHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            report: 'meters',
            reports: {
                reception: ReportReception,
                meters: ControlMeters,
                stock: ReportStock
            }
        }

    }

    componentDidMount(){
        window.initializeSelects('.main-dashboard');
        window.bindSelectAction(this.reportSelect, this._handleSelectChange);
    }

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    render() {

        let ActiveReport = false;
        if(this.state.report){
            ActiveReport = this.state.reports[this.state.report];
        }

        return (
            <div className={'main-dashboard'}>
                <Header active={"reports"}/>

                <div className={'row thin-row'}>
                    <div className={'col s4 input-field'}>
                        <select defaultValue={this.state.report} data-state-var="report"
                                ref={ref => {this.reportSelect = ref}}>
                            <option className="select-option" value="meters">Control de Descarga y Medidores</option>
                            <option className="select-option" value="reception">Recepción de Productos / Movimientos</option>
                            <option className="select-option" value="stock">Stock Mensual / Productos Descargados</option>
                        </select>
                        <label className={"active"}>Tipo de reporte</label>
                    </div>
                </div>
                {ActiveReport &&
                    <ActiveReport />
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportHome)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Reports/index.js